export const en = {
    // Header
    header: {
        contact: {
            phone: "+40 743 131 559",
            email: "office@terasamente.com"
        },
        topBarText: "Over 192+ Quality Machinery Available",
        nav: {
            home: "Home",
            searchMachinery: "All Machinery",
            about: "About Us",
            services: "Services",
            contact: "Contact",
            publishAd: "Publish Ad",
            allCategories: "All Categories",
            selectCategory: "Select a category",
            hotspot: "HotSpot",
            hotspotTitle: "🔥 HotSpot",
            hotspotSubtitle: "Special offers selected for you",
            loadingOffers: "Loading offers...",
            noOffersAvailable: "No special offers at the moment",
            viewFullDetails: "View Full Details",
            negotiable: "NEGOTIABLE",
            year: "YEAR",
            hours: "HOURS",
            location: "LOCATION",
            price: "PRICE",
            quickFilters: "Quick filters:"
        },
        hero: {
            badge: "20+ Years of Excellence",
            title: {
                line1: "Professional Construction",
                line2: "Machinery",
                line3: "for Sale"
            },
            subtitle: "Excavators • Loaders • Compactors • Transport Services • Quality Equipment",
            buttons: {
                browse: "Browse Inventory",
                services: "Our Services"
            },
            features: {
                search: {
                    title: "SEARCH",
                    description: "Find the perfect machinery"
                },
                categories: {
                    title: "CATEGORIES",
                    description: "Filter by category"
                },
                contact: {
                    title: "CONTACT",
                    description: "Get all the information"
                },
                purchase: {
                    title: "Purchase",
                    description: "Test & buy with confidence"
                }
            }
        }
    },

    // Inventory
    inventory: {
        badge: "Latest Additions",
        title: {
            part1: "Featured",
            part2: "Machinery"
        },
        subtitle: "Browse our selection of high-quality construction equipment",
        categories: {
            loaders: "Loaders",
            excavators: "Excavators",
            compactors: "Compactors"
        },
        condition: {
            excellent: "Excellent",
            veryGood: "Very Good",
            good: "Good",
            likeNew: "Like New"
        },
        negotiable: "Negotiable",
        hours: "H",
        viewDetails: "View Details",
        viewAll: "View All Machinery",
        available: "Available"
    },

    // Announcement Details
    announcementDetails: {
        whatsappButton: "Contact on WhatsApp",
        backToListings: "Back to Listings",
        noImagesAvailable: "No images available",
        description: "Description",
        noDescription: "No description provided.",
        details: "Details",
        category: "Category",
        manufacturer: "Manufacturer",
        model: "Model",
        year: "Year",
        condition: "Condition",
        hours: "Hours",
        location: "Location",
        locationTitle: "Location",
        locationNotSpecified: "Location not specified",
        status: "Status",
        views: "views",
        additionalInfo: "Additional Information",
        yearOfManufacture: "Year of Manufacture",
        weight: "Weight",
        power: "Power",
        capacity: "Capacity",
        price: "PRICE",
        negotiable: "Negotiable",
        contactNotAvailable: "Contact not available",
        contactLabel: "Contact",
        detailsLabel: "Details",
        notProvided: "Not provided",
        callNow: "Call Now"
    },

    // Categories Page
    categoriesPage: {
        title: "All Categories",
        subtitle: "Explore the complete range of machinery and equipment available"
    },

    // Filters
    filters: {
        activeFilters: "Active Filters",
        clearAll: "Clear All",
        noFiltersApplied: "No filters applied. Use the filters above to refine your search.",
        remove: "Remove",
        price: "Price",
        year: "Year",
        hours: "Hours",
        now: "Now",
        advancedFilters: "Advanced Filters",
        closeFilters: "Close filters",
        condition: "Condition",
        priceRange: "Price Range",
        yearLabel: "Year",
        minYear: "Min Year",
        maxYear: "Max Year",
        workingHours: "Working Hours",
        minHours: "Min Hours",
        maxHours: "Max Hours",
        brands: "Brands",
        clearAllFilters: "Clear All Filters",
        advancedFiltersButton: "Advanced Filters"
    },
    
    // Machinery Page
    machineryPage: {
        searchPlaceholder: "Search by name, brand, model...",
        gridView: "Grid View",
        listView: "List View",
        sortBy: {
            newest: "Newest First",
            priceLow: "Price: Low to High",
            priceHigh: "Price: High to Low",
            yearNew: "Year: Newest",
            yearOld: "Year: Oldest",
            hoursLow: "Hours: Lowest"
        },
        applyingFilters: "Applying filters...",
        machinesFound: "Machines Found",
        machineFound: "Machine",
        noResultsTitle: "No machinery found",
        noResultsMessage: "Try adjusting your search criteria",
        clearFilters: "Clear Filters",
        premiumEquipment: "Premium Equipment",
        available: "AVAILABLE",
        support: "SUPPORT",
        browseTitle: "Browse Our",
        browseTitleHighlight: "Premium Machinery",
        browseSubtitle: "Discover top-quality construction equipment tailored to your project needs.",
        browseSubtitle2: "From excavators to loaders, find the perfect match for your next job.",
        loadingMachinery: "Loading machinery...",
        errorRetry: "Retry",
        hotspotBadge: "🔥 HotSpot",
        year: "Year",
        hours: "Hours",
        location: "Location",
        power: "Power",
        weight: "Weight",
        bucket: "Bucket",
        moreFeatures: "more features",
        negotiable: "Negotiable",
        price: "Price",
        callNow: "Call Now",
        viewDetails: "View Details"
    },
    
    // Condition Types
    conditionTypes: {
        'nou': 'New',
        'second-hand': 'Second Hand',
        'reconditionat': 'Refurbished'
    },
    
    // Subsub Categories
    subsubCategories: {
        'excavatoare pe șenile': 'Tracked Excavators',
        'excavatoare pe roți': 'Wheeled Excavators',
        'excavatoare pentru fier vechi': 'Scrap Excavators',
        'mini excavatoare': 'Mini Excavators',
        'Cilindri compactori': 'Compactor Rollers',
        'Cilindri mici': 'Small Rollers',
        'Cilindri tandem': 'Tandem Rollers',
        'Cilindri Polipneu': 'Pneumatic Rollers',
        'Încărcătoare frontale': 'Front Loaders',
        'Încărcătoare telescopice': 'Telescopic Loaders',
        'Mini încărcătoare': 'Mini Loaders'
    },

    // Category Names
    categoryNames: {
        'utilaje-constructii': 'CONSTRUCTION MACHINERY',
        'transport': 'TRUCKS (TRANSPORT)',
        'utilaje-agricole': 'AGRICULTURAL MACHINERY',
        'autoturisme-autoutilitare': 'CARS AND VANS',
        'excavatoare': 'EXCAVATORS',
        'buldoexcavatoare': 'BACKHOE LOADERS',
        'buldozere': 'BULLDOZERS',
        'cilindri-compactori': 'ROLLERS',
        'gredere': 'GRADERS',
        'incarcatoare': 'LOADERS',
        'dumpere': 'DUMPERS (SITE TRUCKS)',
        'automacarale': 'CRANE TRUCKS',
        'autobetoniere': 'CONCRETE MIXERS',
        'masini-asfalt': 'ASPHALT MACHINES',
        'sivuitoare': 'FORKLIFTS',
        'nacele': 'AERIAL PLATFORMS',
        'statii-sortare': 'SORTING STATIONS',
        'concasoare': 'CRUSHERS',
        'accesorii-echipamente': 'ACCESSORIES AND EQUIPMENT',
        'dezmembrari': 'MACHINERY PARTS',
        'diverse': 'MISCELLANEOUS',
        'camioane': 'TRUCKS',
        'trailere': 'TRAILERS',
        'semiremorci': 'SEMI-TRAILERS',
        'matura-stradala': 'ROAD SWEEPERS',
        'tractoare': 'TRACTORS',
        'combine': 'COMBINES',
        'echipamente-agricole': 'AGRICULTURAL EQUIPMENT',
        'autoturisme': 'CARS',
        'autoutilitare': 'VANS (LIGHT COMMERCIAL)',
        'remorci': 'TRAILERS'
    },

    // Call to Action
    cta: {
        badge: "Get Started Today",
        title: "Ready to Find Your Perfect Machine?",
        subtitle: "Contact us now and let our experts help you choose the right construction equipment for your needs. We're here to help!",
        callNow: "Call Now",
        sendEmail: "Send Email",
        seeInventory: "See Machinery",
        features: {
            response: "Fast response in 24h",
            consultation: "Free consultation",
            warranty: "Quality guarantee"
        },
        stats: {
            years: "10+",
            experience: "Years Experience",
            machines: "500+",
            sold: "Machines Sold",
            customers: "98%",
            satisfied: "Satisfied Clients"
        }
    },

    // Why Choose Us
    whyChooseUs: {
        badge: "Why MachineryA3",
        title: "Why Choose Us?",
        subtitle: "We provide the best construction machinery solutions with unmatched quality and service",
        features: {
            quality: {
                title: "Quality Guaranteed",
                description: "All our machinery undergoes rigorous inspection to ensure top performance and reliability"
            },
            certified: {
                title: "Certified Equipment",
                description: "Every machine comes with complete documentation and certification for your peace of mind"
            },
            delivery: {
                title: "Fast Delivery",
                description: "We offer reliable and fast delivery services across Romania and Europe"
            },
            support: {
                title: "24/7 Support",
                description: "Our dedicated team is always ready to assist you with any questions or concerns"
            },
            experience: {
                title: "Expert Experience",
                description: "Over 20 years of experience in the construction machinery industry"
            },
            pricing: {
                title: "Competitive Pricing",
                description: "Fair and transparent pricing with flexible payment options available"
            }
        },
        trust: {
            awards: {
                title: "Industry Recognition",
                description: "Awarded for excellence in machinery sales"
            },
            rating: {
                title: "5-Star Reviews",
                description: "Trusted by hundreds of satisfied customers"
            },
            guarantee: {
                title: "Money-Back Guarantee",
                description: "Your satisfaction is our priority"
            }
        }
    },

    // FAQ
    faq: {
        badge: "Frequently Asked Questions",
        title: {
            part1: "Have",
            part2: "Questions?"
        },
        subtitle: "Find quick answers to the most common questions about purchasing and using our machinery",
        categories: {
            buying: "Buying Process",
            delivery: "Transport & Delivery",
            payment: "Payments & Financing",
            warranty: "Warranty & Service"
        },
        buying: [
            {
                question: "How can I purchase machinery from you?",
                answer: "The process is simple: search for the desired machinery on our website, contact us by phone or email for details, schedule a visit to our location to test the equipment, and if satisfied, finalize the purchase. Our team will guide you through each step."
            },
            {
                question: "Can I test the machinery before purchase?",
                answer: "Yes, absolutely! We encourage all customers to visit our location in Luna, Cluj to test the machinery. You can schedule a complete demonstration to check the performance and technical condition of the equipment."
            },
            {
                question: "Are the machines technically inspected?",
                answer: "Yes, all machinery in our inventory is rigorously inspected and technically verified before being offered for sale. We provide complete documentation about the history and technical condition of each machine."
            },
            {
                question: "Can I negotiate the price?",
                answer: "Yes, most of our machinery has negotiable prices. We are open to discussions to reach an agreement that suits both parties. Contact us to discuss special offers."
            }
        ],
        delivery: [
            {
                question: "Do you offer transport services?",
                answer: "Yes, we offer complete oversized transport services throughout Romania and Europe. We have experience in safely delivering machinery of all sizes, including excavators, loaders, and compactors."
            },
            {
                question: "How long does delivery take?",
                answer: "Delivery time depends on the destination and transport availability. Generally, deliveries in Romania take 2-5 business days, and international deliveries take 5-14 days. We will provide an exact timeframe upon order completion."
            },
            {
                question: "How much does transport cost?",
                answer: "Transport cost varies depending on machinery size, distance, and delivery location accessibility. We will provide a detailed transport quote once we know your order details."
            },
            {
                question: "What documents are needed for delivery?",
                answer: "For delivery you will need: identification document, company registration documents (if applicable), sale-purchase contract, and special permits for oversized transport if necessary."
            }
        ],
        payment: [
            {
                question: "What payment methods do you accept?",
                answer: "We accept multiple payment methods: bank transfer, cash (for smaller amounts), bank cards, and installment payments through our financial partners. Discuss with our team to find the most convenient option."
            },
            {
                question: "Do you offer financing options?",
                answer: "Yes, we collaborate with partner financial institutions that can offer leasing and credit solutions for machinery purchase. We can help with preparing the necessary documentation and finding the best financing offer."
            },
            {
                question: "Is a down payment required?",
                answer: "Usually, we request a 20-30% down payment to reserve the machinery and start the delivery process. The remaining amount is paid before or upon delivery, depending on the established agreement."
            },
            {
                question: "Do you issue tax invoices?",
                answer: "Yes, we issue tax invoices for all transactions. If you are registered as a VAT payer, we can issue the invoice with deductible VAT. We provide all necessary documents for accounting."
            }
        ],
        warranty: [
            {
                question: "Do the machines come with warranty?",
                answer: "Second-hand machinery comes with a limited warranty period that varies by model and year. We also offer warranty extension options. New machinery comes with the manufacturer's full warranty."
            },
            {
                question: "What does the warranty cover?",
                answer: "The warranty covers major mechanical and hydraulic system failures that occur under normal operating conditions. It does not cover normal wear, consumables, or damage caused by improper use."
            },
            {
                question: "Do you offer service and maintenance?",
                answer: "Yes, we have partnerships with authorized service centers and can recommend specialists for periodic maintenance and necessary repairs. We also provide consultation for preventive maintenance."
            },
            {
                question: "What happens if the machinery has problems after purchase?",
                answer: "If you encounter problems during the warranty period, contact us immediately. We will evaluate the situation and provide support for repairs or replacement of defective parts according to warranty terms. Customer satisfaction is our priority."
            }
        ],
        contact: {
            title: "Didn't find the answer?",
            subtitle: "Our team is ready to help with any question",
            button: "Contact Us"
        }
    },

    // Footer
    footer: {
        description: "Your trusted partner for quality construction machinery. We provide professional equipment sales, expert consultation, and comprehensive after-sales support.",
        quickLinks: {
            title: "Quick Links",
            home: "Home",
            inventory: "Inventory",
            about: "About Us",
            services: "Services",
            contact: "Contact"
        },
        categories: {
            title: "Categories",
            loaders: "Loaders",
            excavators: "Excavators",
            compactors: "Compactors",
            bulldozers: "Bulldozers",
            cranes: "Cranes"
        },
        contact: {
            title: "Contact Us",
            location: "Romania",
            hours: "Working Hours",
            schedule: "Mon - Fri: 8:00 AM - 6:00 PM\nSat: 9:00 AM - 2:00 PM"
        },
        copyright: "All rights reserved.",
        privacy: "Privacy Policy",
        terms: "Terms of Service",
        cookies: "Cookie Policy"
    },

    // Contact Page
    contactPage: {
        hero: {
            title: "Contact Us",
            subtitle: "We're here to help you find the perfect equipment"
        },
        cards: {
            phone: {
                title: "Call Us",
                schedule: "Monday-Friday 8:00 - 18:00"
            },
            email: {
                title: "Email",
                response: "We respond within 24 hours"
            },
            location: {
                title: "Visit Us",
                area: "Luna, Cluj"
            },
            hours: {
                title: "Schedule",
                weekdays: "Monday - Friday",
                saturday: "Saturday",
                sunday: "Sunday",
                closed: "Closed"
            }
        },
        map: {
            title: "Our Location",
            subtitle: "Visit us to see the equipment in person"
        },
        quickContact: {
            title: "Quick Contact",
            whatsapp: "WhatsApp",
            call: "Call",
            email: "Email"
        },
        social: {
            title: "Follow Us"
        },
        faq: {
            title: "Frequently Asked Questions",
            q1: {
                question: "Do you offer financing?",
                answer: "Yes, we work with multiple financial partners to offer flexible payment plans tailored to your needs."
            },
            q2: {
                question: "Can I test the equipment?",
                answer: "Absolutely! Schedule a visit and our team will arrange a demonstration for any equipment you're interested in."
            },
            q3: {
                question: "Do you provide delivery?",
                answer: "Yes, we offer delivery services throughout Romania and neighboring countries at competitive prices."
            },
            q4: {
                question: "What about warranty?",
                answer: "All our equipment comes with full warranty coverage. Terms vary depending on the machine and condition."
            }
        }
    },

    // Common
    common: {
        language: "Language",
        theme: "Theme",
        lightMode: "Light Mode",
        darkMode: "Dark Mode",
        announcements: "announcements"
    },

    // Cookie Consent
    cookieConsent: {
        title: "We Value Your Privacy",
        description: "We use cookies to improve your experience, remember your language preference, and track announcement views. By clicking \"Accept All\", you consent to our use of cookies.",
        customize: "Customize Settings",
        detailsIntro: "Choose which cookies you want to accept. Necessary cookies are always enabled as they are essential for the website to function.",
        necessary: "Necessary Cookies",
        required: "Required",
        necessaryDesc: "Essential for the website to function properly. These cannot be disabled.",
        functional: "Functional Cookies",
        functionalDesc: "Remember your language preference and track which announcements you've viewed to provide accurate view counts.",
        analytics: "Analytics Cookies",
        optional: "Optional",
        analyticsDesc: "Help us understand how visitors use our website (currently not used).",
        langCookie: "Stores your language preference (EN/RO)",
        viewCookie: "Tracks viewed announcements to prevent duplicate counts",
        acceptAll: "Accept All",
        declineAll: "Decline All",
        savePreferences: "Save Preferences",
        back: "Back",
        footerText: "Learn more in our",
        cookiePolicy: "Cookie Policy"
    },

    // Admin Panel
    admin: {
        images: "Images",
        videos: "Videos",
        imageCount: "images",
        videoCount: "videos",
        new: "new",
        existing: "Existing",
        deleteImage: "Delete image",
        deleteVideo: "Delete video",
        addMoreImages: "Add more images",
        addMoreVideos: "Add more videos",
        imageFormats: "Accepted formats: JPG, PNG, GIF, WEBP (max 5MB each)",
        videoFormats: "Accepted formats: MP4, MOV, AVI, WMV, FLV, WebM, MKV • Max 300MB per video",
        multipleSelect: "You can select multiple files at once or add one at a time",
        newSelected: "new selected",
        limitReached: "Limit reached",
        maxImages: "10 images max",
        maxVideos: "3 videos max",
        successPublished: "Announcement published successfully!",
        successUpdated: "Announcement updated successfully!",
        successDeleted: "Announcement deleted successfully!",
        hotspotAdded: "Announcement added to HotSpot!",
        hotspotRemoved: "Announcement removed from HotSpot!",
        existingImages: "Existing images",
        existingVideos: "Existing videos",
        newImages: "New images",
        newVideos: "New videos",
        contact: "Contact (Phone)",
        location: "Location"
    },

    // Cookie Policy
    cookiePolicy: {
        title: "Cookie Policy",
        lastUpdated: "Last updated: January 27, 2026",
        
        section1: {
            title: "1. What are cookies?",
            content: "Cookies are small text files that are placed on your computer, tablet or mobile phone when you visit a website. Cookies are widely used to make websites work or work more efficiently, as well as to provide information to the owners of the site."
        },
        
        section2: {
            title: "2. How we use cookies",
            content: "MachineryA3 uses cookies for the following purposes:",
            items: {
                essential: "Essential cookies: Necessary for the basic operation of the site, including navigation and access to secure areas.",
                preferences: "Preference cookies: Allow the site to remember information that changes the behavior or appearance of the site, such as your preferred language or the region you are in.",
                analytics: "Analytics cookies: Help us understand how visitors interact with our site by collecting and reporting information anonymously.",
                marketing: "Marketing cookies: Used to track visitors across websites to display ads that are relevant and engaging to the individual user."
            }
        },
        
        section3: {
            title: "3. Types of cookies we use",
            necessary: {
                title: "Strictly necessary cookies",
                description: "These cookies are essential for you to be able to navigate the site and use its features. Without these cookies, the services you have requested cannot be provided.",
                cookies: {
                    consent: "Stores your cookie consent preferences",
                    session: "Identifies your unique session on the site"
                }
            },
            performance: {
                title: "Performance cookies",
                description: "These cookies collect information about how visitors use a website, for example which pages visitors visit most often and whether they receive error messages from web pages.",
                cookies: {
                    ga: "Google Analytics: Used to distinguish users",
                    gid: "Google Analytics: Used to distinguish users",
                    viewTracking: "Tracks announcement views for internal analytics"
                }
            },
            functional: {
                title: "Functionality cookies",
                description: "These cookies allow the website to remember choices you make (such as your preferred language) and provide enhanced, more personal features.",
                cookies: {
                    language: "Stores language preference (RO/EN)",
                    viewedAnnouncements: "Tracks viewed announcements for accurate statistics"
                }
            },
            marketing: {
                title: "Marketing cookies",
                description: "These cookies are used to track visitors across websites. The intention is to display ads that are relevant and engaging to the individual user.",
                cookies: {
                    fbp: "Facebook Pixel: Tracks visits and conversions",
                    adsPreference: "Stores advertising preferences"
                }
            }
        },
        
        section4: {
            title: "4. Third-party cookies",
            content: "In some special cases, we also use cookies provided by trusted third parties. The following section details which third-party cookies you may encounter through this site.",
            items: {
                analytics: "Google Analytics: One of the most widespread and trusted online analytics tools that helps us understand how you use the site and how we can improve your experience.",
                social: "Social Media: Cookies from social media platforms (Facebook, Instagram) to allow you to share content."
            }
        },
        
        section5: {
            title: "5. Managing cookies",
            content1: "You can control and/or delete cookies as you wish. You can delete all cookies that are already on your computer and you can set most browsers to prevent them from being placed.",
            content2: "If you do this, however, you may have to manually adjust some preferences every time you visit a site and some services and features may not work.",
            browserTitle: "How to manage cookies in your browser:",
            browsers: {
                chrome: "Chrome: Settings → Privacy and security → Cookies and other site data",
                firefox: "Firefox: Options → Privacy and security → Cookies and site data",
                safari: "Safari: Preferences → Privacy → Cookies and website data",
                edge: "Edge: Settings → Cookies and site permissions → Manage and delete cookies"
            }
        },
        
        section6: {
            title: "6. Your consent",
            content1: "When you visit our site for the first time, you will be asked to accept or reject cookies. You can change your preferences at any time using the cookie settings panel available on our page.",
            content2: "Accepting cookies is completely voluntary, but please note that refusing cookies may affect the functionality of the site."
        },
        
        section7: {
            title: "7. Cookie lifespan",
            content: "The lifespan of cookies varies depending on their type:",
            items: {
                session: "Session cookies: Temporary and are deleted when you close your browser",
                persistent: "Persistent cookies: Remain on your device for a defined period or until you manually delete them"
            }
        },
        
        section8: {
            title: "8. Updates to this policy",
            content1: "We reserve the right to update this Cookie Policy periodically to reflect, for example, changes to the cookies we use or for other operational, legal or regulatory reasons.",
            content2: "Please review this Cookie Policy periodically to stay informed about our use of cookies and related technologies."
        }
    }
};
